// extracted by mini-css-extract-plugin
export default {"clickable":"P3t2qvUPxV","input":"IyQ8m5F2iF"};